import { FC } from 'react'
import HistorischeDataView from './HistorischeDataView'

const HistorischeDataGebiedList: FC = () => <HistorischeDataView mode="gebied" />

export default HistorischeDataGebiedList
